<template>
  <div class="auth_wrapper w">
    <!-- 标题 -->
    <div class="auth_title">
      <div class="auth_title_name">
        <img
          class="mgr10"
          src="@/assets/pc/mini-title5.png"
          alt=""
        >
        <span>{{ componentInfo.config.title }}</span>
        <!-- <span>京东教育合作讲师/实战专家</span> -->
      </div>
      <NuxtLink
        to="/tch/list"
        style="display:flex;align-items: center;"
      >
        <div class="auth_title_more pointer">
          <span>更多</span>
          <img
            src="https://huawei-newykt-32.obs.cn-north-4.myhuaweicloud.com/1675680587354451969/b664ce8a19524213aa04cf6c928f69dd.png"
            class="arrows"
          />
        </div>
      </NuxtLink>
    </div>
    <!-- 列表 -->
    <div class="banner">
      <div
        class="banner-content"
        @mouseout="mout"
        @mouseover="mover"
      >
        <ul
          class="banner-list"
          style="height: 304px"
        >
          <li
            v-for="(authList, index) in authChunk"
            :key="index"
            class="item"
            :class="{ on: index === num }"
          >
            <NuxtLink
              v-for="auth in authList"
              :key="auth.id"
              :to="'/tch/view?id=' + auth.id"
              class="auth_item_wrapper"
            >
              <div class="auth_item">
                <div class="auth_item_image">
                  <img :src="auth.coverUrl" />
                  <div class="ps_name">{{ auth.schoolName }}</div>
                </div>
                <div class="teacher_item_info">
                  <div>
                    <h3>{{ auth.schoolName }}</h3>
                    <div class="info_box">{{ auth.schoolDesc }}</div>
                  </div>
                  <div>
                    <div class="tag_box">
                      <div class="item_tag">{{ auth.tagName }}院校</div>
                    </div>
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
        </ul>
        <ul class="page_dots">
          <span
            v-for="(item, index) in authChunk"
            :key="index"
            class="dots"
            :class="{ on: index === num }"
            @mouseenter="num = index"
          ></span>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'
import { chunk } from 'lodash-es'
const props = defineProps({
  componentInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
console.log("props.componentInfo", props.componentInfo);
const authChunk = computed(() => {
  return chunk(props.componentInfo.data, 4)
})
const num = ref(0)
const interval = ref(null)
const change = () => {
  interval.value = setInterval(() => {
    if (num.value + 1 >= authChunk.value.length) {
      num.value = 0
    } else {
      num.value++
    }
  }, 5000)
}
const mout = () => {
  change()
}
const mover = () => {
  clearInterval(interval.value)
}
</script>
<style lang="scss" scoped>
.auth_wrapper {
  padding: 25px 0px;
}

.auth_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  line-height: 22px;
  color: #333;

  .auth_title_name {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 34px;

    img {
      width: 180px;
    }

    span {
      font-size: 14px;
      color: #333;
      margin-left: 40px;
    }
  }

  .auth_title_more {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;

    span {
      margin-right: 6px;
    }

    .arrows {
      width: 16px;
      height: 16px;
      padding-right: 0px;
    }
  }
}

.banner {
  position: relative;

  .banner-content {
    margin: 0 auto;
    position: relative;
    // background: #e3e3e3;
  }

  ul {
    position: relative;
  }

  .banner-list {}

  .item {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    opacity: 0;
    height: 100%;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    transition: all 1s;

    &.on {
      opacity: 1;
      z-index: 10;
    }

  }

  .page_dots {
    cursor: pointer;
    margin-top: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px 0;
    border-radius: 13px;
    height: 26px;

    // background: rgba(0, 0, 0, 0.2);
    &.old {
      left: 0;
      right: 0;
      margin-right: 0;
      bottom: 30px;
    }

    .dots {
      display: inline-block;
      width: 8px;
      height: 6px;
      margin: 0 4px;
      background: #BECADB;
      border-radius: 15px;

      &.on {
        width: 14px;
        background: #888;
      }
    }
  }
}

.auth_item_wrapper {
  height: 154px;
  width: 50%;
  padding: 0px 10px;
  box-sizing: border-box;
  position: relative;

  .auth_item {
    width: 100%;
    height: 100%;
    padding: 12px 12px 12px 0px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .auth_item_image {
      height: 100%;
      width: 45%;
      border-radius: 8px;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .ps_name {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 24px;
        z-index: 9;
        text-align: center;
        line-height: 24px;
        color: #fff;
        background-color: #e85c15;
      }
    }

    .teacher_item_info {
      height: 100%;
      width: 53%;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h3 {
        margin: 0;
        padding: 0;
        font-size: 18px;
        line-height: 26px;
        margin-bottom: 4px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .info_box {
        width: 100%;
        font-size: 14px;
        line-height: 24px;
        color: #888;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .tag_box {
        width: 100%;

        .item_tag {
          display: inline-block;
          padding: 1px 6px;
          line-height: 14px;
          box-sizing: border-box;
          background-color: #f20000;
          font-size: 12px;
          margin-right: 6px;
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
</style>